import { Link } from 'react-router-dom';
import { footerLinks, siteConfig } from '@/mocks/navigation';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-1">
            <Link
              to="/"
              className="text-xl font-bold font-heading text-background-50 hover:text-primary-400 transition-colors duration-200"
            >
              {siteConfig.name}
            </Link>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              {siteConfig.tagline}
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200"
                aria-label="领英"
                rel="nofollow"
              >
                <i className="ri-linkedin-line text-sm"></i>
              </a>
            </div>
          </div>

          {[footerLinks.product, footerLinks.resources, footerLinks.company, footerLinks.legal].map(
            (section) => (
              <div key={section.title}>
                <h4 className="text-sm font-semibold text-background-50 mb-4">
                  {section.title}
                </h4>
                <ul className="flex flex-col gap-2.5">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.href}
                        className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )
          )}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} {siteConfig.name}. 保留所有权利。
          </p>
          <p className="text-xs text-background-500">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="hover:text-primary-400 transition-colors duration-200"
            >
              京ICP备2024000001号
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}